import { getEnv } from 'util/getEnv';
import LoadMapsSuspense from './load-maps-suspense/load-maps-suspense.component';

const LoadMaps = ({ children }) => {
  return getEnv('NODE_ENV') === 'test' ? (
    children
  ) : (
    <LoadMapsSuspense>{children}</LoadMapsSuspense>
  );
};
export default LoadMaps;
